// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rdfkD","logo":"Header_logo__8ff4F","gnb":"Header_gnb__BwuH3","active":"Header_active__O+IMM"};